import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../../..";
import { CustomAction } from "../../customAction";
import { API_GET_UPDATE_PROPERTY_DETAILS_FORM_FIELDS_JSON, API_GET_UPDATE_BUILDING_SAFETY_FEATURES_FORM_FIELDS_JSON, API_GET_UPDATE_USAGE_AND_OCCUPANCY_FORM_FIELDS_JSON, API_POLICY_CHANGE } from "../../../Apis/ApiEndPoints";
import { IBOPPropertyDetailsUpdateRequestParams, IBOPBuildingSafetyFeaturesUpdateRequestParams, IBOPUsageAndOccupancyUpdateRequestParams, IBOPFormFieldsResponse } from "../../../models/user/PolicyChange/BOPPolicyChange";
import { IPolicyChangeResponse } from "../../../models/user/PolicyChange/PolicyChange";

export const GetBOPPropertyDetailsFormJson = createAsyncThunk(
  "bopPolicyChange/GetBOPPropertyDetailsFormJson",
  async (_, { dispatch }) => {
    try {
      const response: IBOPFormFieldsResponse = await CustomAction(
        Api.get(API_GET_UPDATE_PROPERTY_DETAILS_FORM_FIELDS_JSON),
        dispatch,
        "bopPolicyChange/GetBOPPropertyDetailsFormJson"
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const GetBOPBuildingSafetyFeaturesFormJson = createAsyncThunk(
  "bopPolicyChange/GetBOPBuildingSafetyFeaturesFormJson",
  async (_, { dispatch }) => {
    try {
      const response: IBOPFormFieldsResponse = await CustomAction(
        Api.get(API_GET_UPDATE_BUILDING_SAFETY_FEATURES_FORM_FIELDS_JSON),
        dispatch,
        "bopPolicyChange/GetBOPBuildingSafetyFeaturesFormJson"
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const GetBOPUsageAndOccupancyFormJson = createAsyncThunk(
  "bopPolicyChange/GetBOPUsageAndOccupancyFormJson",
  async (_, { dispatch }) => {
    try {
      const response: IBOPFormFieldsResponse = await CustomAction(
        Api.get(API_GET_UPDATE_USAGE_AND_OCCUPANCY_FORM_FIELDS_JSON),
        dispatch,
        "bopPolicyChange/GetBOPUsageAndOccupancyFormJson"
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const UpdateBOPPropertyDetails = createAsyncThunk(
  "bopPolicyChange/UpdateBOPPropertyDetails",
  async (requestParams: IBOPPropertyDetailsUpdateRequestParams, { dispatch }) => {
    const response: IPolicyChangeResponse = await CustomAction(
      Api.post(`${API_POLICY_CHANGE}/updatePropertyDetails`, requestParams),
      dispatch,
      "bopPolicyChange/UpdateBOPPropertyDetails"
    );
    return response;
  }
);

export const UpdateBOPBuildingSafetyFeatures = createAsyncThunk(
  "bopPolicyChange/UpdateBOPBuildingSafetyFeatures",
  async (requestParams: IBOPBuildingSafetyFeaturesUpdateRequestParams, { dispatch }) => {
    const response: IPolicyChangeResponse = await CustomAction(
      Api.post(`${API_POLICY_CHANGE}/updateBuildingSafetyFeatures`, requestParams),
      dispatch,
      "bopPolicyChange/UpdateBOPBuildingSafetyFeatures"
    );
    return response;
  }
);

export const UpdateBOPUsageAndOccupancy = createAsyncThunk(
  "bopPolicyChange/UpdateBOPUsageAndOccupancy",
  async (requestParams: IBOPUsageAndOccupancyUpdateRequestParams, { dispatch }) => {
    const response: IPolicyChangeResponse = await CustomAction(
      Api.post(`${API_POLICY_CHANGE}/updateUsageAndOccupancy`, requestParams),
      dispatch,
      "bopPolicyChange/UpdateBOPUsageAndOccupancy"
    );
    return response;
  }
); 